export default __webpack_public_path__ + "static/media/search.f4b2f235.svg";